<template>
  <div
    v-if="currentStep !== totalSteps"
    @click="toggleRegistrationMenu"
    class="registration-steps-mobile"
    :class="{
      'open-reg-steps': registrationMenu,
      'open-reg-steps-mobile': currentStep !== totalSteps
    }"
    v-click-outside-registration="onClickOutsideRegistration"
  >
    <!-- Visible on Mobile-->
    <div class="title">{{ $lang.messages.registrationProgress }} :</div>
    <span class="steps-count">
      {{ currentStep }} of {{totalSteps}}
    </span>
    
    <div
      class="infos-tooltip registration-info-tooltip"
      :class="{ 'registration-info-tooltip-visible': registrationMenu }"
    >
  
      <!-- Invite Co-parent -->
      <reg-steps-box
        :text="$lang.messages.invTheCoparent"
        :whatStep="coparentAdded"
        :isShown="true"
        :isDisabledClass="false"
      >
      </reg-steps-box>
      <!-- Add children -->
      <reg-steps-box
          :text="$lang.messages.addChildren"
          :whatStep="childAdded"
          :isShown="childAdded"
          :isDisabledClass="childAdded === 'unfinished'"
          ref="step2"
      >
      </reg-steps-box>
  
      <!-- Add your bank account -->
      <reg-steps-box
        :text="$lang.messages.addYourBankAccount"
        :whatStep="bankAccountAdded"
        :isShown="bankAccountAdded"
        :isDisabledClass="bankAccountAdded === 'unfinished'"
        ref="step4"
      >
      </reg-steps-box>
  
      <!-- Schedule payment -->
      <reg-steps-box
        :text="$lang.messages.schedulePayments"
        :whatStep="hasScheduledPayments"
        :isShown="hasScheduledPayments"
        :isDisabledClass="hasScheduledPayments === 'unfinished'"
        ref="step5"
      >
      </reg-steps-box>
  
      <!-- Setup Parenting schedule -->
      <reg-steps-box
        :text="$lang.messages.setupParentCalendarSchedule"
        :whatStep="hasEventOrVisitations"
        :isShown="hasEventOrVisitations"
        :isDisabledClass="hasEventOrVisitations === 'unfinished'"
        ref="step6"
      >
      </reg-steps-box>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import vClickOutside from 'v-click-outside';
  import RegistrationStepsBox from "./RegistrationStepsBox";
  
  export default {
    name: "RegSteps",
    components: {
      'reg-steps-box': RegistrationStepsBox
    },
    directives: {
      clickOutsideRegistration: vClickOutside.directive,
    },
    data () {
      return {
        registrationMenu: false
      }
    },
    computed: {
      ...mapGetters([
        'currentStep',
        'totalSteps',
        'coparentAdded',
        'childAdded',
        'bankAccountAdded',
        'hasScheduledPayments',
        'hasEventOrVisitations'
      ])
    },
    methods: {
      onClickOutsideRegistration() {
        this.registrationMenu = false
      },
      toggleRegistrationMenu () {
        this.registrationMenu = !this.registrationMenu;
        this.$emit('closeRegMenu', this.registrationMenu);
      }
    }
  }
</script>
